var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.user.user_type===1||_vm.user.user_type===3)?_c('div',[_c('advHome')],1):_vm._e(),(_vm.user.user_type==5)?_c('div',[_c('parkHome')],1):_vm._e(),(_vm.user.user_type==2||_vm.user.user_type===4)?_c('div',[_c('UnionHome')],1):_vm._e(),(_vm.user.user_type==6)?_c('div',[_c('ShopHome')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }